<template>
<div  :aria-busy="loading ? 'true' : 'false'">
	<section class="content__custom">
		<div class="main-title">
			<h1 class="campaigns">
				{{ 'send-messages' | translate }}
			</h1>
			<h2>{{ 'notifications-subtitle' | translate | capitalize }}</h2>
		</div>

		<alert :conditional="user.premium == 0"
			:classFather="'alert bg-yellow'"
			:title="'no-premium-title'"
			:message="'no-premium-text'"
			:iconClass="'icon fas fa-trophy'"
			:linkShow="false"
			:close-button="false">
		</alert>

		<div class="boxes">
			<div class="box">
				<div class="box box__container">
						<div class="box__body">
							<form @submit.prevent="notificationsRegister" @input="formError = null">

							<div class="switch-field" v-if="user.organization.has_email_broadcast">
								<span>
									<label>Enviar essa campanha por email?</label>
								</span>
								<input
									type="radio"
									id="radio-one"
									name="send_email"
									value="0"
									checked
									v-model="notifications.send_email"
								>
								<label for="radio-one"> {{ 'no' | translate | capitalize }} </label>

								<input
									type="radio"
									id="radio-two"
									name="send_email"
									value="1"
									v-model="notifications.send_email"
								>
								<label for="radio-two">  {{ 'yes' | translate | capitalize }} </label>
							</div>
							<div class="form__group" v-show="notifications.send_email === '1'">
								<label for="subject">{{ 'subject' | translate | capitalize }}</label>
								<input
									type="text"
									v-model="notifications.email_subject"
									maxlength=78
								>
							</div>

							<div class="form__group">
								<label for="name">{{ 'message' | translate | capitalize }}</label>
								<textarea v-model="notifications.content" @input="count" maxlength="500"  :disabled="user.premium === 0"></textarea>
								<span id="countchar" class="label bg-red"></span>
							</div>

							<div class="form__group">
								<div class="form__group__title">
									<label :for="'upload-file'">
										{{ 'file-reply' | translate | capitalize }}
									</label>
									<p class="label-subtitle">
										{{ 'send-file-instructions' | translate | capitalize }}
									</p>
								</div>
								<div class="form__group__uploader">
									<input type="text"  :placeholder="fileName" class="form__group__uploader--disabled" disabled>
									<label :for="'upload-file'" class="form__group__uploader__label">
										<input
										:id="'upload-file'"
										type="file"
										ref="fileupload"
										name="file"
										@change="handleFileUpload($event)"
										accept="image/*, video/*, audio/* video/mp4,video/x-m4v, .mov, .mp4, .x-m4v, .mp3, .png, .gif, .wav, .m4v">
										<!-- {{ 'select' | translate | capitalize }} -->
										<span id="file-selected"></span>
									</label>
									<div v-if="this.selectedFile" @click="resetFile()" class="form__group__remove-attachment">
										<i class="fas fa-times"></i>
										{{ 'remove-attachment' | translate | titleCase }}
									</div>
								</div>
							</div>

							<div class="form__group">
								<div class="image-preview" v-if="imageData.length > 0">
									<img class="preview" :src="imageData">
								</div>
							</div>

							<div class="has-error" v-if="errorMessage != ''">
								<label><i class="fas fa-times-circle-o"></i>{{ errorMessage }}</label>
							</div>


							<div class="form__group">
								<label for="groups">{{ 'Grupos' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'campaign-segment' | translate | capitalize }}</p>

								<select
									@change="controlGroupsSelected($event)"
									:disabled="user.premium == 0 || allGroupsSelected"
									required
								>

								<option
									:selected="(successMsg) ? true : null || groupsFilterToSendNotification.length === 0"
									value="all"
								>
									Todos
								</option>
								<option v-for="(group, index) in groupsToFilterNotification.groups" :key="group.id" :value="group.id">{{group.name}}</option>
							</select>

								<ul class="tags" v-if="groupsFilterToSendNotification">
									<li class="tags__tag" v-for="filter in groupsFilterToSendNotification" :key="filter.id">
										{{ filter.name }}
										<div class="tags__tag__close" @click="removeFilter(filter)">
											<i class="fas fa-times"></i>
										</div>
									</li>
								</ul>
								<span v-show="filterExists"> Esse filtro já foi inserido</span>

							</div>
							<div class="form__group submit__content">
								<button
									type="submit"
									:aria-busy="submitLoading ? 'true' : 'false'"
									:class="submitLoading ? 'button--loading' : ''"
									:disabled="user.premium == 0 || submitLoading"
								>
								<template v-if="submitLoading">
									<img src="/assets/images/loading-white.svg" alt="loading">
								</template>
									<template v-else>
										{{ 'send' | translate | capitalize }}
									</template>
								</button>
							</div>
							<div class="has-error" v-if="formError">
								<label><i class="fas fa-times-circle-o"></i>{{ formError }}</label>
							</div>
							<div class="form__group has-success has-message text-center">
								<label for="inputSuccess" v-show="successMsg"><i class="fas fa-check"></i>
									{{ 'message-sent' | translate | capitalize }}
								</label>
							</div>
							</form>
						</div>
					</div>
				</div>
			</div>
	</section>
</div>
</template>
<script>

	import alert from '../../components/alert/alert.vue';

	export default {
		name: 'send-messages',
		components: {
			alert,
		},
		data() {
			return {
				notifications: {
					name: '',
					email_subject: '',
					send_email: 0,
					content: '',
				},
				successMsg: false,
				groupsToFilterNotification: {},
				groupsFilterToSendNotification: [],
				filterExists: false,
				errorMessage: '',
				formError: null,
				fileName: '',
				attachmentType: '',
				type: '',
				imageData: '',
				selectedFile: null,
				allGroupsSelected: false,
				submitLoading: false,
				loading: false,
			};
		},
		created() {
			const session = { apiKey: sessionStorage.getItem('apiKey'), userId: sessionStorage.getItem('userId') };
			this.$store.dispatch('getGroups', session);
		},
		computed: {
			notification() {
				return this.$store.state.notifications.notification;
			},
			error() {
				return this.$store.state.error;
			},
			user() {
				return this.$store.state.user;
			},
			success() {
				return this.$store.state.status;
			},
			groupCreated() {
				this.groupsToFilterNotification = this.$store.state.group.groups;
			},
		},
		watch: {
			groupCreated() {
				return this.$store.state.group.groups;
			},
		},
		methods: {
			clearError() {
				this.formError = null;
			},
			resetFile() {
				this.$refs.fileupload.value = '';
				this.selectedFile = null;
				this.imageData = '';
				this.type = '';
				this.attachment_type = '';
				this.fileName = '';
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			getFormData(object) {
				const formData = new FormData();
				Object.keys(object).forEach(key => formData.append(key, object[key]));
				return formData;
			},
			toggleLoading() {
				this.loading = !this.loading;
			},
			handleFileUpload(event) {
				const input = event.target;
				const reader = new FileReader();

				this.imageData = '';
				if (input.files && input.files[0]) {
					this.fileSize = event.target.files[0].size;

					if (event.target.files[0].size < 26214400) {
						this.type = 'attachment';
						[this.selectedFile] = event.target.files;
						this.fileName = event.target.files[0].name;

						if ((/(image)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'image';
							reader.onload = (e) => {
								this.imageData = e.target.result;
							};
							reader.readAsDataURL(input.files[0]);
						} else if ((/(audio)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'audio';
						} else if ((/(video)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'video';
						} else {
							this.errorMessage = 'Formato inválido';
						}
					} else {
						this.errorMessage = 'O arquivo excede o tamanho máximo permitido';
						setTimeout(() => {
							this.errorMessage = '';
						}, 4000);
					}
				}
			},
			notificationsRegister(event) {
				const groupsIds = this.groupsFilterToSendNotification.map(p => p.id);

				const payload = {};

				payload.content = this.notifications.content;
				payload.groups = groupsIds;
				payload.send_email = this.notifications.send_email;

				if (this.notifications.content) {
					payload.content = this.notifications.content;
					payload.email_subject = this.notifications.email_subject;
				}

				if (this.selectedFile) {
					payload.type = this.type;
					payload.attachment_type = this.attachmentType;
					payload.file = this.selectedFile;
					this.validationError = 'Anexar arquivos de mídia pode levar alguns minutos. Por favor, não feche esta janela enquanto estiver subindo mídia';
				}

				this.formError = null;
				this.toggleSubmitLoading();
				this.$store.dispatch('notificationsRegister', this.getFormData(payload))
					.then(() => {
						this.validationError = '';
						this.toggleSubmitLoading();
						event.target.reset();
						this.notifications.content = '';
						this.$router.push({ name: 'polls' });
					})
					.catch(() => {
						this.validationError = '';
						this.formError = 'Ocorreu um erro no envio do formulário!';
						this.toggleSubmitLoading();
					});
			},
			controlGroupsSelected(event) {
				this.successMsg = false;
				let error = '';
				this.filterExists = false;
				error = this.groupsFilterToSendNotification.filter(p => p.id === event.target.value).length;
				if (error) {
					this.filterExists = true;
					return;
				}
				if (event.target.value === 'all') {
					this.allGroupsSelected = true;
					this.groupsFilterToSendNotification = [];
				}
				const index = event.target.options.selectedIndex;

				this.groupsFilterToSendNotification.push({
					name: event.target.options[index].textContent,
					id: event.target.value,
				});
			},
			removeFilter(obj) {
				if (obj.id === 'all') {
					this.allGroupsSelected = false;
				}
				this.groupsFilterToSendNotification.splice(obj, 1);
				this.filterExists = false;
			},
			count(event) {
				const lengthText = document.getElementById('countchar');
				lengthText.textContent = (event.target.value.length - 500) * -1;
			},
			errorForm(obj, field) {
				let error = false;
				if (obj) {
					if (obj[field]) {
						error = true;
					}
				}
				return error;
			},
			validate() {
				this.successMsg = this.success;
				setTimeout(() => {
					this.successMsg = false;
				}, 5000);
			},
			collapsePainel(event) {
				$.AdminLTE.boxWidget.collapse($(event.target));
			},
		},
	};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/campaign/campaignsDetails.vue